//API REQUESTS STATES
const prefix = 'useApiRequest/';

export const FETCHING = `${prefix}FETCHING`;
export const SUCCESS = `${prefix}SUCCESS`;
export const ERROR = `${prefix}ERROR`;
